import { computed } from "vue";
import { isNullish } from "@tinyurldev/tu-ui-vue";

import useBillable from "@Composables/useBillable";
import useLimit from "@Composables/useLimit";
import { OVERAGE_STATUS } from "@Constants/overage-status";

export default function useOverage(limitId) {
  const { currentBillable } = useBillable();
  const { usedOverage, hasStatus } = useLimit(limitId);

  const pricingDetails = computed(() => {
    const currentSubscription = currentBillable.value.currentSubscription;

    if (isNullish(currentSubscription)) {
      return null;
    }

    return currentSubscription.overage.find((overage) => {
      return overage.appliesTo === limitId;
    });
  });

  const canOverage = computed(() => {
    // FIXME: It need to be reviewed here https://tinyurl-llc.atlassian.net/browse/TEAM-159.
    const overage = currentBillable.value.limits?.overage;

    if (isNullish(overage)) {
      return false;
    }

    return limitId in overage;
  });

  const hasOverage = computed(() => {
    return usedOverage.value > 0;
  });

  const isOverageOn = computed(() => {
    return hasStatus(OVERAGE_STATUS.BILLABLE_ENABLE);
  });

  const feePerUnit = computed(() => {
    return pricingDetails.value?.price?.amount ?? 0;
  });

  const unitSize = computed(() => {
    return pricingDetails.value?.unitSize ?? 1;
  });

  const pricePerUnit = computed(() => {
    return Math.ceil(usedOverage.value / unitSize.value) * feePerUnit.value;
  });

  return {
    canOverage,
    hasOverage,
    isOverageOn,
    feePerUnit,
    unitSize,
    pricePerUnit,
  };
}
